<template>
  <div id="app">
    <div class="page"></div>
    <a href="https://www.haoyunba.com/h5/mobileprovision/qml_wishchat_profiile_adhot.mobileprovision">
      <div class="foot">信任证书</div>
    </a>

    <div class="tan" :class="{tanhide:codeshow}">
      <div class="tan-page">
           <p>请阅读操作步骤</p>
           <p>下载完成再点击“信任证书”</p>
      </div>
      <div class="tan-foot" @click="closeTan()">
        <span>我知道了！</span>
      </div>
    </div>
    <div class="tan-back" @touchmove.prevent :class="{tanhide:codeshow}"></div>




  </div>
</template>
<script>
import tips from "@/estoast";


export default {
  name: "app",
  data() {
    return {
      msg: "注册协议",
      codeshow: false
    };
  },
  methods: {
     closeTan() {
      this.codeshow = true;
    },
    down() {
      // setTimeout(function() {
      //   window.location.href =
      //     "http://wap.haoyunba.com/mobileprovision/qml.mobileprovision";
      // }, 3000);
      tips.toast("请打开【设置-通用】，添加信任");
    }
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 3098px;
  background-image: url("./img/asd.jpg");
  padding: 0px 0px 40px 0px;
  background-size: 100% 100%;
}
.foot {
  position: absolute;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  height: 136px;
  width: 100%;
  background: linear-gradient(90deg, #6c67fd, #1c61eb);
  line-height: 136px;
  color: white;
  font-size: 32px;
}
.foot {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 998;
}
.tan {
  position: fixed;
  z-index: 9999;
  top: 428px;
  margin: 0 auto;
  position: fixed;
  width: 540px;
  height: 300px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  margin: 0px 104px 0px 106px;
  z-index: 99999;
}

.tan-back {
  position: fixed;
  z-index: 99998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.5);
}

.tan-head {
  width: 100%;
  height: 50px;
}
.tan-head img {
  position: relative;
  width: 32px;
  height: 32px;
  float: right;
  margin: 16px 20px 0 0;
}
.tan-page {
  width: 100%;
  height: 200px;
}
.tan-foot {
  width: 540px;
  height: 102px;
  background: linear-gradient(
    90deg,
    rgba(108, 103, 253, 1) 0%,
    rgba(56, 48, 234, 1) 100%
  );
  border-radius: 0px 0px 16px 16px;
}

.tan-foot span {
  width: 240px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 100px;
}

.tan-page-text {
  width: 100%;
  height: 38px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 38px;
  padding: 20px 0 0 0;
}
.tan-page-code {
  width: 476px;
  height: 100px;
  padding: 30px 0 0 32px;
}
.tan-page-code div {
  float: left;
}

.tan-page-code-img {
  width: 190px;
  height: 92px;
  border-radius: 61px;
}

.tan-page-code-img img {
  width: 190px;
  height: 92px;
}

.tan-page-code-input {
  width: 272px;
  height: 92px;
  margin: 0 0 0 14px;
}
.tan-page-code-input input {
  width: 202px;
  height: 61px;
  background: rgba(247, 247, 247, 1);
  border-radius: 61px;
  border: none;
  padding: 15px 35px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(194, 194, 194, 1);
  line-height: 38px;
  text-align: center;
}

.tan-page-code-input input::-webkit-input-placeholder {
  position: relative;
  left: 20px;
  width: 172px;
  height: 38px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(194, 194, 194, 1);
  line-height: 38px;
  margin-left: -10px;
}
.tanhide {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/iosSetting/iosSetting.vue